import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import def from "csi/def";
import FieldConstructor from "csi/def/Field";
import Widget from "csi/form/Widget";
import locale from "csi/locale";
import { CallMethod } from "csi/xml/CallMethod";

const COPY_CREW = "CopyCrew";

const CopyProductHierarchyLevelMixin = declare(Widget, {

	/**
	 * @override
	 * Insert CopyCrew field
	 */
	_resolveView() {
		this.inherited<CallMethod>(arguments);
		this.insertField(lang.mixin(new FieldConstructor(), {
			m_label: locale.resource(COPY_CREW),
			m_typeControl: def.FIELD_CHECKBOX,
		}));
	},
});

export = CopyProductHierarchyLevelMixin;